import React, { ReactElement, useRef } from 'react';

import styled from 'styled-components';

const MarqueeContainer = styled.div`
  overflow-x: hidden !important;
  display: flex !important;
  flex-direction: row !important;
  position: relative;
  width: 100%;
  &:hover {
    .marquee {
      animation-play-state: var(--pause-on-hover);
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Marquee = styled.div`
  flex: 0 0 auto;
  min-width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);
  animation-play-state: var(--play);
  animation-delay: var(--delay);
  animation-direction: var(--direction);
  @keyframes scroll {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`;

type Props = {
  children: ReactElement[];
  duration: number;
};

export const MarqueeCards: React.FC<Props> = (props) => {
  const containerRef = useRef<HTMLDivElement>();
  const { children, duration } = props;
  const containerStyle = { '--pause-on-hover': 'paused', '--pause-on-click': 'running' };
  const marqueeStyle = {
    '--play': 'running',
    '--direction': 'normal',
    '--duration': `${duration}s`,
    '--delay': '0s',
    '--iteration-count': 'infinite',
  };

  const scrollBack = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  return (
    // @ts-ignore: style
    <MarqueeContainer ref={containerRef} style={containerStyle} onMouseLeave={scrollBack} onTouchEnd={scrollBack}>
      {/* @ts-ignore: style */}
      <Marquee className="marquee" style={marqueeStyle}>
        {children}
      </Marquee>
      {/* @ts-ignore: style */}
      <Marquee className="marquee" style={marqueeStyle}>
        {children}
      </Marquee>
    </MarqueeContainer>
  );
};
